export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_FAIL = "REGISTER_FAIL";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGOUT = "LOGOUT";
export const REFRESH_TOKEN = "REFRESH_TOKEN";

export const SET_MESSAGE = "SET_MESSAGE";
export const CLEAR_MESSAGE = "CLEAR_MESSAGE";

export const SET_USERPROFILE = "SET_USERPROFILE";
export const CLEAR_USERPROFILE = "CLEAR_USERPROFILE";

export const SET_UPLOADFORMPHD_PAGE2 = "SET_UPLOADFORMPHD_PAGE2";
export const SET_UPLOADFORMPOSTDOC_PAGE2 = "SET_UPLOADFORMPOSTDOC_PAGE2";
export const CLEAR_UPLOADFORM_PAGE2 = "CLEAR_UPLOADFORM_PAGE2";

export const EDIT_SUCCESS = "EDIT_SUCCESS";
export const EDIT_FAIL = "EDIT_FAIL";